// MobileAuthFlow — orquestra a NAVEGAÇÃO entre as 3 telas de auth mobile
// (login ↔ signup ↔ recuperação) sem react-router: é um seletor de view local
// (touch, sem rotas dedicadas — o MobileRoot decide auth vs logado).
//
// Ao autenticar (qualquer caminho), chama onAuthenticated() pra o MobileRoot
// re-renderizar e cair no estado logado (a sessão Swipe já foi persistida pelo
// motor). NAVEGAÇÃO é própria da superfície mobile; a LÓGICA de auth é o motor
// compartilhado (account-auth) — separação travada pelo Fernando.

import { useState } from 'react'

import { MobileForgotPassword } from './MobileForgotPassword'
import { MobileLogin } from './MobileLogin'
import { MobileSignup } from './MobileSignup'

type AuthView = 'login' | 'signup' | 'forgot'

interface MobileAuthFlowProps {
  onAuthenticated: () => void
}

export function MobileAuthFlow({ onAuthenticated }: MobileAuthFlowProps): JSX.Element {
  const [view, setView] = useState<AuthView>('login')

  if (view === 'signup') {
    return <MobileSignup onAuthenticated={onAuthenticated} onGoToLogin={() => setView('login')} />
  }
  if (view === 'forgot') {
    return <MobileForgotPassword onGoToLogin={() => setView('login')} />
  }
  return (
    <MobileLogin
      onAuthenticated={onAuthenticated}
      onGoToSignup={() => setView('signup')}
      onGoToForgot={() => setView('forgot')}
    />
  )
}
